import { IAnexo } from "@/services/types";

interface ComponentProps {
    anexos: IAnexo[];
}
export const IFileLinkListSection: React.FC<ComponentProps> = ({ anexos }) => {

    const handleDownload = (url: string, name: string) => {
        const link = document.createElement('a');
        link.href = url;
        link.download = name;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <div className="w-full">
            {
                anexos &&
                anexos.map((anexo, index) =>
                (
                    <div key={index} className={"flex justify-between p-4 items-center rounded-sm shadow-[0px_8.542858123779297px_20.26080894470215px_0px_rgba(139,141,142,0.15)] mb-2"} >
                        <div className="text-lg font-medium font-nunito ml-2">
                            {anexo.highlight_name ? (
                                <>
                                    <span className="text-[#F7941D]">{anexo.highlight_name}</span>
                                    <span className="text-[#2A2A2A]"> {anexo.nameAnexo.replace(anexo.highlight_name, '')}</span>
                                </>
                            ) : (
                                <span className="text-[#2A2A2A]">{anexo.nameAnexo}</span>
                            )}
                        </div>
                        <div className="flex flex-col items-center justify-center">
                            <button
                                type="button"
                                onClick={() => handleDownload((anexo?.linkAnexo || anexo?.fileAnexo?.url) || "", anexo?.fileAnexo?.name || "")}
                                className="w-9 h-9flex items-center justify-center hover:bg-[#377396]/10 transition-colors cursor-pointer"
                                aria-label="Download documento"
                            >
                                <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.75 5.75V12.75M10.75 12.75L13.75 9.75M10.75 12.75L7.75 9.75" stroke="#2A2A2A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M14.75 15.75H10.75H6.75" stroke="#2A2A2A" strokeWidth="1.5" strokeLinecap="round" />
                                    <path opacity="0.5" d="M0.75 10.75C0.75 6.03595 0.75 3.67893 2.21447 2.21447C3.67893 0.75 6.03595 0.75 10.75 0.75C15.464 0.75 17.8211 0.75 19.2855 2.21447C20.75 3.67893 20.75 6.03595 20.75 10.75C20.75 15.464 20.75 17.8211 19.2855 19.2855C17.8211 20.75 15.464 20.75 10.75 20.75C6.03595 20.75 3.67893 20.75 2.21447 19.2855C0.75 17.8211 0.75 15.464 0.75 10.75Z" stroke="#2A2A2A" strokeWidth="1.5" />
                                </svg>
                            </button>
                        </div>
                    </div>
                ))
            }
        </div>
    );
};


